import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { SITE } from "@/lib/site";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/thank-you")({
  head: () => {
    const seo = pageSeo({
      path: "/thank-you",
      title: `Thank You | ${SITE.name}`,
      description: "Thanks for your enquiry. One of our team will be in touch shortly.",
    });
    return {
      ...seo,
      meta: [...seo.meta, { name: "robots", content: "noindex, nofollow" }],
    };
  },
  component: ThankYouPage,
});

function ThankYouPage() {
  return (
    <section className="container mx-auto px-4 py-20 md:py-28">
      <div className="mx-auto max-w-xl rounded-2xl border bg-card p-8 md:p-10 shadow-lift text-center">
        <div className="mx-auto mb-5 inline-flex rounded-full bg-success/10 p-3">
          <CheckCircle2 className="h-12 w-12 text-success" aria-hidden />
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3">Thank You</h1>
        <p className="text-muted-foreground mb-2">
          We've received your enquiry and one of the team will be in touch shortly.
        </p>
        <p className="text-sm text-muted-foreground mb-6">
          For urgent matters please call us on{" "}
          <a href="tel:+448000092992" className="text-accent font-semibold">
            0800 009 2992
          </a>
          .
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-accent px-6 py-3 text-sm font-semibold text-accent-foreground hover:bg-accent/90 transition-colors"
        >
          Back to Home
        </Link>
      </div>
    </section>
  );
}
